<script>
import axios from 'axios'
import Raven from 'raven-js'
import { mapGetters } from 'vuex'

import { getComponents } from '../router/views/utils'
import SubHeader from '@components/sub-header'
import InfoBox from '@components/info-box'
import AMPLITUDE from '@constants/amplitude'
import GTM_CONSTANTS from '@constants/google-tag-manager'
import ENV from '@src/env'
import { widgetActions } from '@state/helpers'
import screens from '@/mixins/fallback-screens.js'

export default {
  name: 'Form',
  components: {
    SubHeader,
    InfoBox,
  },
  mixins: [screens()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: null,
      loading: false,
      error: null,
      childrenList: [],
    }
  },
  computed: {
    ...mapGetters('widgets', ['userEnv', 'logsUserID']),
    parent() {
      const [comp] = getComponents([this.componentData.parent])
      return comp
    },
    children() {
      return getComponents(this.componentData.children)
    },
    infoBoxData() {
      return this.componentData.infobox
    },
    params() {
      const { order_id } = this.$route.query // eslint-disable-line
      const { screenId: screen_id } = this.componentData.children // eslint-disable-line
      const params = Object.assign({}, { order_id }, { screen_id })
      return params
    },
    payloadForlogs() {
      const { screenId } = this.componentData.children
      return Object.assign(
        {},
        { screenId },
        this.$route.params,
        this.$route.query
      )
    },
    viewEvent() {
      const { screenId } = this.componentData.children
      return `REQUEST_FORM_${screenId}`
    },
  },
  watch: {
    showForm() {},
  },
  created() {
    this.fetchScreen()
  },
  methods: {
    ...widgetActions,
    getComponent({ component }) {
      return component()
    },
    onParentChange(childData) {
      this.$scrollTo(`#${this.$options.name}`, 1000)
      this.showForm = !childData
    },
    fetchScreen() {
      this.error = null
      this.loading = true
      return axios
        .post(
          `${
            ENV.rappi.url[this.userEnv]
          }/support-actions-manager/screens/build-screen`,
          this.params,
          {
            headers: { Authorization: `Bearer ${this.$route.query.token}` },
          }
        )
        .then(
          ({ data }) => {
            this.loading = false
            const { screenWidgets } = data.data
            this.childrenList = getComponents(screenWidgets)
            this.childrenList.map(c => this.commitWidgetData(c))
            this.dispatchEventTrack(this.viewEvent)
          },
          err => {
            this.childrenList = getComponents(this.getScreen('baseForm'))
            this.childrenList.map(c => this.commitWidgetData(c))
            Raven.captureException(err)
            this.loading = false
            this.dispatchEventTrack(
              AMPLITUDE.SERVER_ERROR,
              JSON.parse(JSON.stringify(err))
            )
            this.error = err.toString()
          }
        )
    },
    dispatchEventTrack(eventName, payload = this.payloadForlogs) {
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: eventName,
        payload,
        eventType: eventName,
        user: this.userForLogs,
      })
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <component
      :is="getComponent(parent)"
      :class="$style.parent"
      :component-data="JSON.parse(JSON.stringify(parent.data))"
      @onDataChange="onParentChange"
    />

    <InfoBox
      v-if="showForm === false"
      :data="JSON.parse(JSON.stringify(infoBoxData.data))"
      :styles="JSON.parse(JSON.stringify(infoBoxData.styles))"
      :class="$style.infoBox"
    />

    <div
      v-if="showForm"
      :class="$style.children"
    >
      <component
        v-for="child in childrenList"
        :key="child.key"
        :is="getComponent(child)"
        :class="$style.children__child"
        :component-data="JSON.parse(JSON.stringify(child.data))"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" module>
.container {
  padding-bottom: 1rem;
  // margin: 1rem 0;
}

.parent {
  // margin-bottom: 1rem;
  background-color: #fff;
}
.children {
  &__child {
    // padding: 0.5rem 0;
    // margin-bottom: 1rem;
  }
}

.infoBox {
  // margin-bottom: 1rem;
  margin: 1rem auto;
}
</style>
